export default "__VITE_ASSET__B_5lK0yZ__"